import { useState } from 'react'
import { LogoutCurve, Moon, Sun1 } from 'iconsax-react'
import { api } from '../api'

const appVersion = __APP_VERSION__

interface HomeProps {
    theme: 'light' | 'dark'
    onChangeTheme: (next: 'light' | 'dark') => void
    onStart: () => void
    onLogout: () => void
}

export function Home({ theme, onChangeTheme, onStart, onLogout }: HomeProps) {
    const [busy, setBusy] = useState(false)

    async function handleStart() {
        if (busy) return
        setBusy(true)
        try {
            await api.health()
            onStart()
        } catch (err) {
            console.warn('[home] health check failed:', err)
            alert('服务暂时不可用，请稍后再试')
        } finally {
            setBusy(false)
        }
    }

    return (
        <div className="relative flex h-full flex-col justify-between px-12 pt-20 pb-12">
            {/* 顶部操作栏：左=登出 右=主题。几何对齐 Chat 顶栏(h-14 px-4 / h-10 w-10 / -ml-1.5、-mr-1.5),
                两页切换时左右两角的按钮不跳。 */}
            <header className="absolute inset-x-0 top-0 z-10 flex h-14 items-center justify-between px-4">
                <button
                    onClick={onLogout}
                    aria-label="登出"
                    className="-ml-1.5 flex h-10 w-10 items-center justify-center text-text-secondary/85 transition-colors hover:text-text-primary active:opacity-50"
                >
                    <LogoutCurve size={27} color="currentColor" variant="Linear" />
                </button>
                <button
                    onClick={() => onChangeTheme(theme === 'dark' ? 'light' : 'dark')}
                    aria-label="切换主题"
                    className="-mr-1.5 flex h-10 w-10 items-center justify-center text-text-secondary/85 transition-colors hover:text-text-primary active:opacity-50"
                >
                    {theme === 'dark' ? (
                        <Sun1 size={26} color="currentColor" variant="Linear" />
                    ) : (
                        <Moon size={26} color="currentColor" variant="Linear" />
                    )}
                </button>
            </header>

            <div className="animate-rise flex flex-1 flex-col items-center justify-center">
                <h1 className="text-liquid whitespace-nowrap font-display text-[4.5rem] leading-none font-semibold tracking-tight sm:text-7xl">
                    Small Talk
                </h1>
            </div>

            <div className="flex justify-center pb-12 sm:pb-8">
                <button
                    onClick={handleStart}
                    disabled={busy}
                    className="liquid h-14 w-full max-w-[16rem] rounded-full text-lg font-semibold tracking-wide text-white shadow-lg shadow-accent/25 transition active:scale-[0.99] active:opacity-90 disabled:opacity-40"
                >
                    {busy ? '连接中…' : '开始对话'}
                </button>
            </div>
            <div className="fixed right-5 bottom-4 font-display text-xs font-semibold tracking-[0.08em] text-text-secondary/50">
                {appVersion}
            </div>
        </div>
    )
}
